import { render, staticRenderFns } from "./OrderInvoiceDateCell.vue?vue&type=template&id=493a16be&"
import script from "./OrderInvoiceDateCell.vue?vue&type=script&lang=js&"
export * from "./OrderInvoiceDateCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports